import { render, staticRenderFns } from "./Subjects.vue?vue&type=template&id=7c570320&scoped=true"
import script from "./Subjects.vue?vue&type=script&lang=js"
export * from "./Subjects.vue?vue&type=script&lang=js"
import style0 from "./Subjects.vue?vue&type=style&index=0&id=7c570320&prod&lang=scss&scoped=true"
import style1 from "./Subjects.vue?vue&type=style&index=1&id=7c570320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c570320",
  null
  
)

export default component.exports